import type { ActivityModule } from '../../core/activity';
import { mountMoneyCents } from './ui';
import levelsData from './levels.json';
import '../money/style.css';
import './style.css';

export const moneyCents: ActivityModule = {
  id: 'money_cents',
  title: 'Dinheiro com centavos',
  description: 'Pague preços que têm centavos usando moedas (R$ 0,05 a R$ 1) e notas (R$ 2 a R$ 200).',
  ageMin: 8,
  ageMax: 12,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/money_cents/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountMoneyCents,
};
